"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingBalanceLogInfoLinks = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Icon_1 = require("../../../Icon");
const Spinner_1 = require("../../../Spinner/Spinner");
const _1 = require(".");
const AccountingBalanceLogInfoLinks = (props) => {
    const { onClickOverview, overviewPdfLoading, hidden, } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${_1.className}__links` },
        react_1.default.createElement("button", { type: 'button', className: `${_1.className}__link`, onClick: onClickOverview, disabled: overviewPdfLoading },
            overviewPdfLoading ? react_1.default.createElement(Spinner_1.Spinner, null) : react_1.default.createElement(Icon_1.Icon, { name: 'document' }),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog/Info:TransactionOverview', defaultMessage: 'Transaction Overview' }))));
};
exports.AccountingBalanceLogInfoLinks = AccountingBalanceLogInfoLinks;
//# sourceMappingURL=links.js.map